import { useSession } from '@quoter/web-core'

/**
 * The two ids every LowFodmaps row is keyed by, or null while signed out or
 * loading. Rows are private to one person inside their workspace, so every
 * query filters on both — RLS enforces the same pair.
 */
export function useMe(): { orgId: string; userId: string } | null {
  const session = useSession()
  return session.status === 'authenticated'
    ? { orgId: session.organizationId, userId: session.user.id }
    : null
}
